import { Component, OnInit } from '@angular/core';

import { FeedMetadataItem } from '../shared/models/feed-metadata-item.model';
import { FeedMetadataService } from '../shared/feed-metadata.service';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

@Component({
  selector: 'dm-feed-list',
  templateUrl: './feed-list.component.html',
  styleUrls: ['./feed-list.component.css']
})
export class FeedListComponent implements OnInit {
    metadataItems: FeedMetadataItem[];
    error: any;
    errorKey = 'feed-list';

    public isLoaded : boolean = false;
    
    constructor(private feedMetadataService: FeedMetadataService, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

    ngOnInit() {
        this.clearError();
        this.feedMetadataService.list().subscribe(
            items => {
                this.metadataItems = items;
                this.isLoaded = true;
            },
            error => {
                this.error = error;
                this.handleError(error);
            }
        );
    }

    clearError() {
        this.errorManager.removeDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey);
    }

    handleError(error: any) {
        const FeedListNoResponse = 'An unexpected error occurred. Please try again.';
        this.errorManager.saveDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey, error, FeedListNoResponse);
        this.eventLogger.logError(new Error(this.errorManager.dataMinerUiError.message), this.errorManager.dataMinerUiError.message, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-list/feed-list.component.ts